export default "__VITE_ASSET__Cii8vvkT__"